module.exports = __webpack_public_path__ + "img/myers_sunset-38409-002.14a84792.jpg";